import type { LucideIcon } from 'lucide-react'

import {
    AirVent,
    ArrowUpFromLine,
    Armchair,
    Baby,
    Building2,
    Car,
    CookingPot,
    Flame,
    Flower2,
    Plane,
    Sparkles,
    Sunset,
    Trees,
    Tv,
    Umbrella,
    WashingMachine,
    Waves,
    Wifi
} from 'lucide-react'

const ICONS: Record<string, LucideIcon> = {
    pool: Waves,
    shared_pool: Waves,
    sea_view: Sunset,
    beach_access: Umbrella,
    wifi: Wifi,
    ac: AirVent,
    heating: Flame,
    kitchen: CookingPot,
    washing_machine: WashingMachine,
    tv: Tv,
    parking: Car,
    garden: Trees,
    terrace: Armchair,
    rooftop: Building2,
    courtyard: Flower2,
    bbq: Flame,
    housekeeping: Sparkles,
    airport_transfer: Plane,
    baby_cot: Baby,
    elevator: ArrowUpFromLine
}

export const amenityIcon = (key: string): LucideIcon => ICONS[key] ?? Sparkles
